import BlogList from "../components/BlogList";
import { PaperBG } from "../kits/DesignKit";
import Preloader from "../components/Preloader";
import SeoHelmet from "../components/SeoHelmet";

export default function Blog() {
  return (
    <>
    <SeoHelmet
  title="Blog – The Original Bitter"
  description="Unsere neuesten Artikel, Insights & Ideen."
  url="https://denisbitter.de/blog"
/>
    <Preloader>
      <PaperBG>
        <BlogList />
      </PaperBG>
    </Preloader>
    </>
  );
}